var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="form-group--vehicle-heading-' +
__e( n ) +
' col" style="font-weight: bold; font-size: medium;">Vehicle ' +
__e( n ) +
':</div><div class="form-group form-group--vehicle-make-' +
__e( n ) +
'"><label class="' +
__e( labelClass ) +
'">Vehicle make ' +
((__t = ( requiredMarker(required)  )) == null ? '' : __t) +
'</label><div class="' +
__e( controlContainerClass ) +
'"><input type="text" placeholder="Vehicle make" class="' +
__e( controlClass ) +
'"></div><p class="help-block col-xs-12 col-md-3"></p></div><div class="form-group form-group--vehicle-model-' +
__e( n ) +
'"><label class="' +
__e( labelClass ) +
'">Vehicle model ' +
((__t = ( requiredMarker(required)  )) == null ? '' : __t) +
'</label><div class="' +
__e( controlContainerClass ) +
'"><input type="text" placeholder="Vehicle model" class="' +
__e( controlClass ) +
'"></div><p class="help-block col-xs-12 col-md-3"></p></div><div class="form-group form-group--vehicle-registration-number-' +
__e( n ) +
'"><label class="' +
__e( labelClass ) +
'">Vehicle registration number ' +
((__t = ( requiredMarker(required)  )) == null ? '' : __t) +
'</label><div class="' +
__e( controlContainerClass ) +
'"><input type="text" placeholder="Vehicle registration number" class="' +
__e( controlClass ) +
'"></div><p class="help-block col-xs-12 col-md-3"></p></div>';

}
return __p
};

/*
original source:

<div class="form-group--vehicle-heading-<%- n %> col" style="font-weight: bold; font-size: medium;">Vehicle <%- n %>:</div>
<div class="form-group form-group--vehicle-make-<%- n %>">
    <label class="<%- labelClass %>">Vehicle make <%= requiredMarker(required)  %></label>
    <div class="<%- controlContainerClass %>">
        <input type="text" placeholder="Vehicle make" class="<%- controlClass %>" />
    </div>
    <p class="help-block col-xs-12 col-md-3"></p>
</div>

<div class="form-group form-group--vehicle-model-<%- n %>">
    <label class="<%- labelClass %>">Vehicle model <%= requiredMarker(required)  %></label>
    <div class="<%- controlContainerClass %>">
        <input type="text" placeholder="Vehicle model" class="<%- controlClass %>" />
    </div>
    <p class="help-block col-xs-12 col-md-3"></p>
</div>

<div class="form-group form-group--vehicle-registration-number-<%- n %>">
    <label class="<%- labelClass %>">Vehicle registration number <%= requiredMarker(required)  %></label>
    <div class="<%- controlContainerClass %>">
        <input type="text" placeholder="Vehicle registration number" class="<%- controlClass %>" />
    </div>
    <p class="help-block col-xs-12 col-md-3"></p>
</div>

*/
